import { Navigate } from "react-router-dom"
import { AdminAnalyticsClient } from "@/components/admin/analytics/AdminAnalyticsClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function AdminAnalyticsPage() {
  const { user } = useAuth()
  if (!user || user.role !== "admin") return <Navigate to="/feed" replace />
  return <div className="container-app py-4"><AdminAnalyticsClient /></div>
}